import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Table as Table$2 } from '@zillow/constellation';

var _excluded = ["columns", "items", "headerAppearance", "rowKeyAccessor"];
var ALIGNMENTS = {
  left: 'left',
  right: 'right',
  center: 'center'
};

/**
 *  A table component that uses constellation table components underneath
 *  Accepts all the props from constellation Table component
 *
 *  We can look into react-table hooks for a more complex table requirements (pagination, sorting, etc...)
 *
 *  Usage:
 *
 *  const columns = [
 *      {
 *          Header: 'name'
 *          accessor: 'name'
 *      },
 *      {
 *          Header: 'url',
 *          accessor: 'url',
 *          Cell: <Url />
 *      }
 * ]
 *
 *  const items = [
 *      { name: 'henry', url: '/abc' },
 *      { name: 'john', url: '/zxy' },
 * ]
 *
 *  <Table columns={columns} items={items} />
 */
var Table = function Table(_ref) {
  var columns = _ref.columns,
    items = _ref.items,
    headerAppearance = _ref.headerAppearance,
    rowKeyAccessor = _ref.rowKeyAccessor,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Table$2.Responsive, {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(Table$2, restProps, /*#__PURE__*/React.createElement(Table$2.Header, {
    appearance: headerAppearance
  }, /*#__PURE__*/React.createElement(Table$2.Row, null, columns.map(function (_ref2) {
    var Header = _ref2.Header,
      accessor = _ref2.accessor,
      align = _ref2.align;
    return /*#__PURE__*/React.createElement(Table$2.HeaderCell, {
      key: accessor,
      align: align
    }, Header);
  }))), /*#__PURE__*/React.createElement(Table$2.Body, null, items.map(function (item) {
    return /*#__PURE__*/React.createElement(Table$2.Row, {
      key: item[rowKeyAccessor]
    }, columns.map(function (_ref3, colIndex) {
      var accessor = _ref3.accessor,
        Cell = _ref3.Cell,
        align = _ref3.align;
      var content = Cell ? /*#__PURE__*/React.createElement(Cell, item, null) : item === null || item === void 0 ? void 0 : item[accessor];
      return colIndex === 0 ? /*#__PURE__*/React.createElement(Table$2.HeaderCell, {
        key: accessor,
        align: align
      }, content) : /*#__PURE__*/React.createElement(Table$2.Cell, {
        key: accessor,
        align: align
      }, content);
    }));
  }))));
};
Table.propTypes = process.env.NODE_ENV !== "production" ? {
  rowKeyAccessor: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    accessor: PropTypes.string.isRequired,
    Cell: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    align: PropTypes.oneOf(Object.keys(ALIGNMENTS))
  })).isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  headerAppearance: PropTypes.string
} : {};
Table.defaultProps = {
  rowKeyAccessor: 'id',
  items: [],
  headerAppearance: 'light'
};
var Table$1 = Table;

export { ALIGNMENTS, Table$1 as default };
